<template>
	<div class="text-content" v-html="content"></div>
</template>

<script>
	export default {
		props: ['id', 'template', 'content']
	}
</script>